__turbopack_context__.v({
  "accepted": "offer-notifications-module__rcBWzq__accepted",
  "actions": "offer-notifications-module__rcBWzq__actions",
  "amountPill": "offer-notifications-module__rcBWzq__amountPill",
  "bell": "offer-notifications-module__rcBWzq__bell",
  "dropdown": "offer-notifications-module__rcBWzq__dropdown",
  "heading": "offer-notifications-module__rcBWzq__heading",
  "headlineTimestamp": "offer-notifications-module__rcBWzq__headlineTimestamp",
  "list": "offer-notifications-module__rcBWzq__list",
  "manage": "offer-notifications-module__rcBWzq__manage",
  "nameTimestamp": "offer-notifications-module__rcBWzq__nameTimestamp",
  "offer": "offer-notifications-module__rcBWzq__offer",
  "primaryAction": "offer-notifications-module__rcBWzq__primaryAction",
  "review": "offer-notifications-module__rcBWzq__review",
  "rowButton": "offer-notifications-module__rcBWzq__rowButton",
  "secondaryAction": "offer-notifications-module__rcBWzq__secondaryAction",
  "target": "offer-notifications-module__rcBWzq__target",
  "timestamp": "offer-notifications-module__rcBWzq__timestamp",
  "unread": "offer-notifications-module__rcBWzq__unread",
});
